import angular from 'angular'
import { EventsCoordinationReviewComponent } from './events-coordination-review-container.component';
import { SharedModule } from '../shared/shared.module'
import { EventsSchedulingSharedModule } from '../events-scheduling/shared/events-scheduling-shared.module';
/**
 * A module that relates the admin-level maintenance of defining
 * schedule events, and their assignment to ICDs.
 */
export const EventsCoordinationModule = angular
    .module("apex.mainApp.eventsCoordination", [
        EventsSchedulingSharedModule,
        SharedModule
    ])
    .component("apexEventsCoordinationReviewContainer", EventsCoordinationReviewComponent)
    .name;
